import { useEffect, useState } from "react";
import Lenis from "lenis";
import { getSunPhase } from "@/lib/site";
import HeaderNav from "@/components/HeaderNav";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import StoryManifesto from "@/components/StoryManifesto";
import MenuSection from "@/components/MenuSection";
import ReservationSection from "@/components/ReservationSection";
import HowToReachSection from "@/components/HowToReachSection";
import WhatsAppBeacon from "@/components/WhatsAppBeacon";
import FooterSection from "@/components/FooterSection";

export default function PublicSite() {
  const [phase, setPhase] = useState(getSunPhase);

  useEffect(() => {
    document.documentElement.dataset.theme = phase;
  }, [phase]);

  useEffect(() => {
    const id = setInterval(() => setPhase(getSunPhase()), 60000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <div className={`sun-overlay sun-${phase}`} data-testid="sun-overlay" aria-hidden="true" />
      <HeaderNav />
      <main>
        <HeroSection />
        <EditorialMarquee />
        <StoryManifesto />
        <MenuSection />
        <ReservationSection />
        <HowToReachSection />
      </main>
      <FooterSection />
      <WhatsAppBeacon />
    </div>
  );
}
